import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { ContentBlock, FlexGap, FlexJustify, Padding, useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { MailTagCollection } from '../../../../Mailboxes/Components/Tags/MailTagCollection';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';

function MailItemTagsMetaBlock() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { UpdateMailTags, mailItemData } = useMailbox();

	if (!mailItemData || !mailItemData?.tags || mailItemData?.tags?.length === 0) {
		return null;
	}

	return (
		<ContentBlock
			title={t('mailItem.labels.tags')}
			content={
				<MailTagCollection
					mailUuid={mailItemData?.mailUuid}
					tags={mailItemData?.tags}
					hideIcon
					removeCallback={(tagId: number) => UpdateMailTags({ value: tagId }, false)}
				/>
			}
			iconContent={{ icon: faTag, iconSpacing: FlexGap.Small, iconSize: 'lg' }}
			padding={Padding.ExtraSmall}
			stacked={isTiny || isSmall || isMedium}
			justify={FlexJustify.Start}
		/>
	);
}

function MailItemTagsMetaInline() {
	const { UpdateMailTags, mailItemData } = useMailbox();

	if (!mailItemData || !mailItemData?.tags || mailItemData?.tags?.length === 0) {
		return null;
	}

	return (
		<>
			<h6 className='pageantry-sub-heading text-left mb-0'>Tags</h6>
			<div className='pt-sm pb-sm'>
				<MailTagCollection
					mailUuid={mailItemData?.mailUuid}
					tags={mailItemData?.tags}
					hideIcon
					removeCallback={(tagId: number) => UpdateMailTags({ value: tagId }, false)}
				/>
			</div>
		</>
	);
}

export { MailItemTagsMetaBlock, MailItemTagsMetaInline };
